import ready from './ready';

function invalidSelect(event) {
	event.target.parentElement.classList.add('-invalid');
	event.preventDefault();
}

function inputSelect(event) {
	// remove the validation error message if the input is now valid
	if (event.target.validity.valueMissing === false) {
		event.target.parentElement.classList.remove('-invalid');
	}
}

function invalidRadio(event) {
	event.target.parentElement.classList.add('-invalid');
	event.preventDefault();
}

function inputRadio(event) {
	// remove the validation error message if the input is now valid
	if (event.target.validity.valueMissing === false) {
		const elements = event.target.parentElement.parentElement.children;
		Array.prototype.forEach.call(elements, (el) => {
			el.classList.remove('-invalid');
		});
	}
}

function invalidText(event) {
	event.target.parentElement.classList.add('-invalid');
	event.preventDefault();
}

function invalidEmail(event) {
	const parent = event.target.parentElement;
	const error = parent.querySelector('.validation-message');
	let errorMessage = 'Please complete this field';
	if (event.target.validity.typeMismatch === true) {
		errorMessage = 'Please enter a valid email';
	}
	error.innerText = errorMessage;
	parent.classList.add('-invalid');
	event.preventDefault();
}

function inputText(event) {
	if (event.target.validity.valueMissing === false) {
		event.target.parentElement.classList.remove('-invalid');
	}
}

function inputEmail(event) {
	if (event.target.validity.valueMissing === false) {
		event.target.parentElement.classList.remove('-invalid');
	}
}

function invalidCheck(event) {
	event.target.parentElement.classList.add('-invalid');
	event.preventDefault();
}

function inputCheck(event) {
	if (event.target.validity.valueMissing === false) {
		event.target.parentElement.classList.remove('-invalid');
	}
}

ready.then(() => {
	// select
	const selects = document.querySelectorAll('select.input-select__select');
	Array.prototype.forEach.call(selects, (el) => {
		el.addEventListener('invalid', invalidSelect);
		el.addEventListener('input', inputSelect);
	});

	// radio answers
	const radios = document.querySelectorAll('input[type="radio"]');
	Array.prototype.forEach.call(radios, (el) => {
		el.addEventListener('invalid', invalidRadio);
		el.addEventListener('input', inputRadio);
	});

	// text inputs
	const text = document.querySelectorAll('input[type="text"]');
	Array.prototype.forEach.call(text, (el) => {
		el.addEventListener('invalid', invalidText);
		el.addEventListener('input', inputText);
	});

	// email inputs - handled deparately to text fields because of more complex validation conditions
	const email = document.querySelectorAll('input[type="email');
	Array.prototype.forEach.call(email, (el) => {
		el.addEventListener('invalid', invalidEmail);
		el.addEventListener('input', inputEmail);
	});

	const checkbox = document.querySelectorAll('input[type="checkbox"]');
	Array.prototype.forEach.call(checkbox, (el) => {
		el.addEventListener('invalid', invalidCheck);
		el.addEventListener('input', inputCheck);
	});
});
